let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lHLf9")).then(() => parcelRequire('lqvu5'));